import '@ninox/ninox-components/main.css';
import '@ninox/ninox-components/fonts.css';

import React, { Suspense } from 'react';

import { createRoot } from 'react-dom/client';
import { MainSpinner } from '@ninox/ninox-components/lib/Spinner';

import { App } from './App';
import { StyleSheetManager, ThemeProvider } from 'styled-components';
import { light } from '@ninox/ninox-components/theme';

const container = document.getElementById('root');

if (container) {
    createRoot(container).render(
        <StyleSheetManager>
            <ThemeProvider theme={light}>
                <Suspense fallback={<MainSpinner />}>
                    <App />
                </Suspense>
            </ThemeProvider>
        </StyleSheetManager>
    );
}
